import { render, staticRenderFns } from "./multiselect.vue?vue&type=template&id=fefc2334&"
import script from "./multiselect.vue?vue&type=script&lang=js&"
export * from "./multiselect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/contactum-new/contactum-new/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fefc2334')) {
      api.createRecord('fefc2334', component.options)
    } else {
      api.reload('fefc2334', component.options)
    }
    module.hot.accept("./multiselect.vue?vue&type=template&id=fefc2334&", function () {
      api.rerender('fefc2334', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/admin/components/form-templates/multiselect.vue"
export default component.exports